/**
 * A janela de captura é um OVERLAY global (AppShell), não uma rota — /capture existe só
 * como deep-link (legado: parameters.capture → showSearch sobre a home): abre o overlay
 * do módulo pedido e cai na Home por trás.
 */
import { useEffect } from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useCaptureStore } from '../stores/captureStore';
import { isVisibleListModule, type ListModule } from '../config/constants';

export function CaptureRedirect(): JSX.Element {
  const [searchParams] = useSearchParams();
  const openCaptureWindow = useCaptureStore((s) => s.openCaptureWindow);
  const param = searchParams.get('module');
  const module: ListModule = isVisibleListModule(param) ? param : 'emails';
  useEffect(() => {
    openCaptureWindow(module);
  }, [module, openCaptureWindow]);
  return <Navigate to="/" replace />;
}
